import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const UserProfile: React.FC = () => {
   const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
   useEffect(() => {
         setToken(localStorage.getItem('token')); // Reactively update token state
     if(!token){
         window.location.href = "/";
     }
    }, []);
  return (
    <div>
      <Link to= '/articles'>Article </Link>
      {/* Add your user profile content here */}
    </div>
  );
};

export default UserProfile;